/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Failure(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                viewBox='0 0 25.01 25.01'
                xmlns='http://www.w3.org/2000/svg'
            >
                <title>failure</title>
                <g
                    data-name='Layer 2'
                    id='Layer_2'
                >
                    <g
                        data-name='Layer 1'
                        fill={iconColor || '#EFEFEF'}
                        id='Layer_1-2'
                    >
                        <path d='M12.5,25A12.51,12.51,0,1,1,25,12.5,12.52,12.52,0,0,1,12.5,25Zm0-24A11.5,11.5,0,1,0,24,12.5,11.51,11.51,0,0,0,12.5,1Z' />
                        <path d='M17,8.19a.44.44,0,0,0-.61,0L12.52,11.9,8.8,8a.44.44,0,0,0-.61,0,.43.43,0,0,0,0,.61l3.71,3.85L8,16.21a.43.43,0,0,0,0,.61.46.46,0,0,0,.31.13.42.42,0,0,0,.3-.12l3.85-3.72L16.21,17a.43.43,0,0,0,.31.14.43.43,0,0,0,.31-.73l-3.72-3.86L17,8.8A.44.44,0,0,0,17,8.19Z' />
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}